
















import {Vue,Component,Prop, Watch,Mixins} from 'vue-property-decorator';

@Component({
    
})
export default  class  TimeInput extends Vue{

}
